import React from "react";



export function DeleteUserContainer({ accessToken, name, email }) {
  return(
      <p>DeleteUser</p>
  )
}
 